import { Icon } from './Icon.js';

/** Form-level failure, for errors that belong to no single input. */
export function FormBanner({ message }: { message: string | null }) {
  if (!message) {
    return null;
  }

  return (
    <p className="form-banner" role="alert">
      <Icon name="alertCircle" size={15} />
      <span>{message}</span>
    </p>
  );
}
